import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  key: 1,
  class: "px-6 py-2"
};
const _hoisted_2 = {
  class: "grid grid-cols-12 gap-4 pb-2"
};
const _hoisted_3 = {
  class: "col-span-10"
};
const _hoisted_4 = {
  class: "text-sm text-gray-800 bg-white"
};
const _hoisted_5 = ["href"];
const _hoisted_6 = {
  key: 0,
  class: "col-span-2"
};
const _hoisted_7 = {
  class: "flex py-1"
};
const _hoisted_8 = {
  key: 0,
  class: "grid grid-cols-4 gap-4"
};
const _hoisted_9 = {
  class: "col-span-2"
};
const _hoisted_10 = {
  class: "w-4/12"
};
const _hoisted_11 = {
  class: "leading-10"
};
const _hoisted_12 = {
  class: "w-8/12"
};
const _hoisted_13 = {
  key: 0,
  class: "col-span-2"
};
const _hoisted_14 = {
  class: "w-4/12"
};
const _hoisted_15 = {
  class: "leading-10"
};
const _hoisted_16 = {
  class: "w-8/12"
};
const _hoisted_17 = {
  class: "col-span-2"
};
const _hoisted_18 = {
  class: "w-75"
};
const _hoisted_19 = {
  class: "ledes-code-set py-2"
};
const _hoisted_20 = {
  class: "flex-1"
};
const _hoisted_21 = {
  class: "font-bold"
};
const _hoisted_22 = {
  class: ""
};
import SnackbarComponent from '@/components/SnackbarComponent.vue';
import { reactive, onMounted, computed } from 'vue';
import MainHeader from '@/components/MainHeader.vue';
import ProductNotice from '@/components/ProductNotice.vue';
import LlSelect from '@/components/LlSelect.vue';
import LlSwitch from '@/components/LlSwitch.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import RouteService from '@/services/RouteService';
import ListsService from '@/services/ListsService';
import SettingsSaveBar from '@/components/SettingsSaveBar.vue';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
import { useCompanyBillingStore } from '@/modules/settings/integrations/QBO/companyBillingStore';
import { useMeStore } from '@/services/UserService/useMeStore';
import Loader from '@/components/Loader.vue';
import axios from 'axios';
import { storeToRefs } from 'pinia';
import { getSortedArray } from '@/services/utils';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import { useSupportChat } from '@/composables/useSupportChat';
import LlTextField from '@/components/LlTextField.vue';
import LlCheckbox from '@/components/LlCheckbox.vue';
export default {
  __name: 'LedesSettings',
  props: {
    rootScope: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const {
      getSupportUrl: _getSupportUrl
    } = useSupportChat();
    const ledesSupportUrl = computed(() => _getSupportUrl('ledesBilling'));
    const props = __props;
    let ledesState = reactive({
      loading: false,
      saving: false,
      unsaved: false,
      featureEnabled: null,
      codes: {},
      categories: [],
      roles: [],
      ledesXmlUserRoles: [],
      form: {
        categories: [],
        classification: {},
        classificationXml: {},
        accountingService: null
      },
      selectedCodeSets: [],
      initialSelectedCodeSets: [],
      currentSelection: null,
      accountingServices: {},
      insertMatterShareComponent: false
    });
    const meStore = useMeStore();
    const companyStore = useCompanyStore();
    const listsService = new ListsService();
    const {
      features
    } = storeToRefs(useMeStore());
    const {
      companySettings
    } = storeToRefs(useCompanyStore());
    const companyBillingStore = useCompanyBillingStore();
    const {
      handleError,
      handleSuccess
    } = useSnackbarHandler();
    onMounted(async () => {
      const [,,, categories] = await Promise.all([meStore.getMe(), companyStore.loadMyCompany(), companyBillingStore.getAccountingServices(), axios({
        url: '/codes/categories'
      })]);
      ledesState.categories = categories.data || [];
      ledesState.accountingServices = companyBillingStore.accountingServices;
      initializeLedesState();
      const deactivate = new RouteService(props).rootScopeChange().$on('$stateChangeStart', event => {
        if (somethingChanged.value) {
          ledesState.unsaved = true;
          setTimeout(() => {
            ledesState.unsaved = false;
          }, 4000);
          event.preventDefault();
        } else {
          deactivate();
        }
      });
    });
    function initializeLedesState() {
      ledesState.codes = companySettings.value.codes || {};
      ledesState.roles = listsService.getUserRoles('ledes1998').filter(role => role.id !== 'accountant');
      ledesState.ledesXmlUserRoles = listsService.getUserRoles('ledesXml2');
      const defaultClassification = {
        principal: '',
        lead: '',
        paralegal: '',
        operator: '',
        timekeeper: ''
      };
      ledesState.codes.classification = ledesState.codes.classification && Object.keys(ledesState.codes.classification).length > 0 ? ledesState.codes.classification : {
        ...defaultClassification
      };
      ledesState.codes.classificationXml = ledesState.codes.classificationXml && Object.keys(ledesState.codes.classificationXml).length > 0 ? ledesState.codes.classificationXml : {
        ...defaultClassification
      };
      ledesState.form = resetForm();
      const selected = ledesState.categories?.map(category => ({
        ...category,
        included: !!ledesState.codes.categories?.find(id => id === category.id)
      })).filter(item => item.included);
      ledesState.selectedCodeSets = [...ledesState.selectedCodeSets, ...selected];
      ledesState.initialSelectedCodeSets = JSON.parse(JSON.stringify(ledesState.selectedCodeSets));
      if (!companySettings.value.codes?.categories) {
        ledesState.form.categories = ledesState.form.categories.map(categorie => ({
          ...categorie,
          included: !!(categorie.id == 'lit')
        }));
      }
    }
    function ledesStatusToggle() {
      ledesState.form.ledes = !ledesState.form.ledes;
    }
    async function cancel() {
      ledesState.selectedCodeSets = JSON.parse(JSON.stringify(ledesState.initialSelectedCodeSets));
      ledesState.form = resetForm();
    }
    function addSelectedItem(newItem) {
      if (!ledesState.selectedCodeSets.some(item => item.id === newItem.id)) {
        ledesState.selectedCodeSets.push(newItem);
      }
      updateCategories();
    }
    function removeCodeSet(category) {
      ledesState.selectedCodeSets = ledesState.selectedCodeSets.filter(c => c.id !== category.id);
      updateCategories();
    }
    function resetForm() {
      return {
        ledes: ledesState.codes.ledes,
        externalId: ledesState.codes.externalId,
        taxId: ledesState.codes.taxId,
        invoiceDescription: ledesState.codes.invoiceDescription,
        standard: ledesState.codes.categories ? ledesState.codes.categories.indexOf('nostandard') == -1 : true,
        categories: ledesState.categories.data?.map(category => ({
          ...category,
          included: !!ledesState.codes.categories?.find(id => id === category.id)
        })),
        classification: JSON.parse(JSON.stringify(ledesState.codes.classification || [])),
        classificationXml: JSON.parse(JSON.stringify(ledesState.codes.classificationXml || [])),
        accountingService: ledesState.codes.accountingService && Object.keys(ledesState.codes.accountingService).length > 0 ? ledesState.codes.accountingService : null,
        populateDescriptions: !!ledesState.codes.populateDescriptions && !ledesState.codes.prependLedesDescriptions,
        populateDescriptionsPlus: !!ledesState.codes.populateDescriptionsPlus && !!ledesState.codes.populateDescriptions && !ledesState.codes.prependLedesDescriptions,
        prependLedesDescriptions: !!ledesState.codes.prependLedesDescriptions && !ledesState.codes.populateDescriptions,
        expenseAttachments: ledesState.codes.expenseAttachments,
        insertMatterShareComponent: ledesState.codes.insertMatterShareComponent,
        noSelectingGroup: ledesState.codes.noSelectingGroup || false
      };
    }
    function updateCategories() {
      const updatedCategories = ledesState.selectedCodeSets.filter(item => !item.id.includes('default')).map(item => item.id);
      ledesState.form.categories = updatedCategories;
    }
    async function update() {
      ledesState.saving = true;
      if (ledesState.form.ledes) {
        ledesState.form.categories = ledesState.categories.filter(c => c.included).map(c => c.id);
        if (!ledesState.form.standard) {
          ledesState.form.categories.push('nostandard');
        }
      } else {
        ledesState.form.categories = null;
      }
      ['classification', 'classificationXml'].forEach(key => {
        if (ledesState.form[key].length === 0) {
          ledesState.form[key] = {};
        }
      });
      updateCategories();
      syncWithApi();
    }
    async function syncWithApi() {
      try {
        ledesState.saving = true;
        await companyStore.updateMyCompany({
          settings: {
            codes: ledesState.form
          }
        });
        ledesState.codes = companySettings.value.codes || {};
        ledesState.form = resetForm();
        handleSuccess('Settings updated successfully.');
      } catch (error) {
        handleError('Error updating settings.');
      } finally {
        ledesState.saving = false;
        ledesState.loading = false;
      }
    }
    function handlePopulateDescriptionsChange(value) {
      ledesState.form.populateDescriptions = value;
      if (!value) {
        ledesState.form.populateDescriptionsPlus = false;
      }
      if (value) {
        ledesState.form.prependLedesDescriptions = false;
      }
    }
    function handlePrependLedesDescriptionsChange(value) {
      ledesState.form.prependLedesDescriptions = value;
      if (value) {
        ledesState.form.populateDescriptions = false;
        ledesState.form.populateDescriptionsPlus = false;
      }
    }
    const somethingChanged = computed(() => {
      return JSON.stringify(ledesState.form) !== JSON.stringify(resetForm());
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(SnackbarComponent, {
        ref: "snackbar"
      }, null, 512), _unref(ledesState).loading ? (_openBlock(), _createBlock(Loader, {
        key: 0,
        what: 'LEDES Billing',
        class: "mt-32"
      })) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(MainHeader, {
        content: "LEDES Billing"
      }), _createElementVNode("div", _hoisted_4, [_cache[14] || (_cache[14] = _createTextVNode(" When enabled, this allows matters to be set up with LEDES billing. More information can be found ", -1)), _createElementVNode("a", {
        href: ledesSupportUrl.value,
        target: "_blank",
        rel: "noopener noreferrer"
      }, [...(_cache[13] || (_cache[13] = [_createElementVNode("span", {
        class: "text-primary font-medium"
      }, " here ", -1)]))], 8, _hoisted_5)])]), _unref(features).ledes ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
        class: "py-1.5 px-1 cursor-pointer",
        onClick: _cache[0] || (_cache[0] = $event => ledesStatusToggle()),
        "data-cy": "ledes-status"
      }, _toDisplayString(_unref(ledesState).form.ledes ? 'Enabled' : 'Disabled'), 1), _createVNode(LlSwitch, {
        modelValue: _unref(ledesState).form.ledes,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(ledesState).form.ledes = $event)
      }, null, 8, ["modelValue"])])])) : _createCommentVNode("", true)]), _createVNode(ProductNotice, {
        product: 'ledes',
        state: __props.state,
        label: 'LEDES codes are'
      }, null, 8, ["state"]), _unref(features).ledes ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_withDirectives(_createElementVNode("div", _hoisted_9, [_createVNode(LlTextField, {
        placeholder: "Enter Law Firm Id",
        modelValue: _unref(ledesState).form.externalId,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(ledesState).form.externalId = $event),
        labelClass: "w-full",
        info: "This will go in all LEDES files under the LAW_FIRM_ID column",
        label: "LEDES Law Firm Id"
      }, null, 8, ["modelValue"]), _createVNode(LlTextField, {
        placeholder: "Enter Law Firm Tax Id",
        modelValue: _unref(ledesState).form.taxId,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(ledesState).form.taxId = $event),
        labelClass: "w-full",
        info: "This is required for the LEDES 2000 format but not used for LEDES\n            1998b",
        label: "LEDES Law Firm Tax Id"
      }, null, 8, ["modelValue"]), _createVNode(LlTextField, {
        placeholder: "Invoice Description",
        modelValue: _unref(ledesState).form.invoiceDescription,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(ledesState).form.invoiceDescription = $event),
        labelClass: "w-full",
        info: "This overrides the description normally assigned to invoices (draft\n            = 'Draft', approved = 'Interim', open = 'Final'). You can also\n            override this for individual clients under the LEDES page for the\n            client.",
        label: "Default Invoice Description"
      }, null, 8, ["modelValue"]), _createElementVNode("div", {
        class: _normalizeClass(['grid', _unref(features).ledesXml2 ? 'grid-cols-4' : 'grid-cols-2'])
      }, [_createElementVNode("div", {
        class: _normalizeClass(['ms-1', _unref(features).ledesXml2 ? 'col-span-2' : 'col-span-4'])
      }, [_cache[15] || (_cache[15] = _createElementVNode("label", {
        class: "py-2"
      }, "LEDES Timekeeper Classification Codes - 1998B ", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ledesState).roles, (role, idx) => {
        return _openBlock(), _createElementBlock("div", {
          key: idx,
          class: "flex w-full mb-4"
        }, [_createElementVNode("div", _hoisted_10, [_createElementVNode("label", _hoisted_11, _toDisplayString(role.label), 1)]), _createElementVNode("div", _hoisted_12, [_createVNode(LlTextField, {
          placeholder: role.ledes,
          modelValue: _unref(ledesState).form.classification[role.id],
          "onUpdate:modelValue": $event => _unref(ledesState).form.classification[role.id] = $event,
          labelClass: "w-full"
        }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"])])]);
      }), 128))], 2), _unref(features).ledesXml2 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_cache[16] || (_cache[16] = _createElementVNode("label", {
        class: "py-2"
      }, "LEDES Timekeeper Classification Codes - New ", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ledesState).ledesXmlUserRoles, (role, idx) => {
        return _openBlock(), _createElementBlock("div", {
          key: idx,
          class: "flex w-full mb-4"
        }, [_createElementVNode("div", _hoisted_14, [_createElementVNode("label", _hoisted_15, _toDisplayString(role.label), 1)]), _createElementVNode("div", _hoisted_16, [_createVNode(LlTextField, {
          placeholder: role.ledes,
          modelValue: _unref(ledesState).form.classificationXml[role.id],
          "onUpdate:modelValue": $event => _unref(ledesState).form.classificationXml[role.id] = $event,
          labelClass: "w-full"
        }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"])])]);
      }), 128))])) : _createCommentVNode("", true)], 2), _createVNode(LlCheckbox, {
        label: "Use LEDES description in time and expense entries",
        modelValue: _unref(ledesState).form.populateDescriptions,
        "onUpdate:modelValue": [_cache[5] || (_cache[5] = $event => _unref(ledesState).form.populateDescriptions = $event), handlePopulateDescriptionsChange],
        labelClass: "py-2",
        disabled: _unref(ledesState).form.prependLedesDescriptions
      }, null, 8, ["modelValue", "disabled"]), _createVNode(LlCheckbox, {
        label: "Use both activity and task code descriptions",
        modelValue: _unref(ledesState).form.populateDescriptionsPlus,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _unref(ledesState).form.populateDescriptionsPlus = $event),
        labelClass: "py-2",
        disabled: !_unref(ledesState).form.populateDescriptions || _unref(ledesState).form.prependLedesDescriptions,
        info: "When enabled, time entries will include both activity and task code descriptions in the format '(Activity code), (Task code)' instead of replacing one with the other."
      }, null, 8, ["modelValue", "disabled"]), _unref(features).recumbentOtters ? (_openBlock(), _createBlock(LlCheckbox, {
        key: 0,
        label: "Prepend LEDES Descriptions",
        modelValue: _unref(ledesState).form.prependLedesDescriptions,
        "onUpdate:modelValue": [_cache[7] || (_cache[7] = $event => _unref(ledesState).form.prependLedesDescriptions = $event), handlePrependLedesDescriptionsChange],
        labelClass: "py-2",
        disabled: _unref(ledesState).form.populateDescriptions,
        info: "Line item descriptions will be prepended with the LEDES descriptions in downloaded LEDES files. Cannot be enabled with Use LEDES description in time and expense entries."
      }, null, 8, ["modelValue", "disabled"])) : _createCommentVNode("", true), _withDirectives(_createVNode(LlCheckbox, {
        label: "Expense Attachments & LEDES",
        modelValue: _unref(ledesState).form.expenseAttachments,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _unref(ledesState).form.expenseAttachments = $event),
        labelClass: "py-2"
      }, null, 8, ["modelValue"]), [[_vShow, _unref(features).expenseAttachments]]), _unref(features).ledesXml2 ? (_openBlock(), _createBlock(LlSelect, {
        key: 1,
        modelValue: _unref(ledesState).form.accountingService,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _unref(ledesState).form.accountingService = $event),
        items: _unref(getSortedArray)(_unref(ledesState).accountingServices?.services),
        "item-title": "name",
        "item-value": "id",
        "return-object": "",
        placeholder: "Select Format",
        label: "Special Expense Format Product/Service",
        isAutocomplete: "",
        info: "Expenses assigned to this product/service will use the Special Expense Format, if configured to do so in client level LEDES settings.",
        "hide-details": true,
        labelClass: "py-2"
      }, null, 8, ["modelValue", "items"])) : _createCommentVNode("", true), _unref(features).expenseAttachments && _unref(features).ledesXml2 ? (_openBlock(), _createBlock(LlCheckbox, {
        key: 2,
        label: "   Insert Matter Share components",
        modelValue: _unref(ledesState).form.insertMatterShareComponent,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _unref(ledesState).form.insertMatterShareComponent = $event),
        info: "When enabled inserts matter_perc_shar_fees and matter_perc_shar_exp\n          in the MATTER segment of LEDES XML 2.0 invoices. Does not enable\n          automatic split invoices.",
        labelClass: "py-2"
      }, null, 8, ["modelValue"])) : _createCommentVNode("", true)], 512), [[_vShow, _unref(ledesState).form.ledes]]), _withDirectives(_createElementVNode("div", _hoisted_17, [_createElementVNode("label", _hoisted_18, [_createVNode(LlSelect, {
        modelValue: _unref(ledesState).currentSelection,
        "onUpdate:modelValue": [_cache[11] || (_cache[11] = $event => _unref(ledesState).currentSelection = $event), addSelectedItem],
        items: _unref(ledesState).categories,
        info: "This determines which codes are available to you when assigning time entries and expenses to LEDES codes",
        "item-title": "label",
        "item-value": "id",
        "return-object": "",
        placeholder: "Select",
        label: "LEDES Code Sets",
        isAutocomplete: "",
        "hide-details": true,
        labelClass: "py-2",
        "data-cy": "ledes-code-set"
      }, null, 8, ["modelValue", "items"])]), _createVNode(LlCheckbox, {
        label: "Disable Generalized Codes",
        modelValue: _unref(ledesState).form.noSelectingGroup,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => _unref(ledesState).form.noSelectingGroup = $event),
        info: "While enabled, users will be unable to select generalized LEDES codes (100, 200, etc.)",
        labelClass: "py-2"
      }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ledesState).selectedCodeSets, (category, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: category.id,
          class: "flex items-center bg-green-100 p-2 my-2"
        }, [_createElementVNode("div", _hoisted_20, [_createElementVNode("strong", _hoisted_21, _toDisplayString(category.label), 1), _createElementVNode("p", _hoisted_22, _toDisplayString(category.description), 1)]), _createVNode(LlSecondaryButton, {
          icon: "mdi-window-close",
          color: "primary",
          variant: "text",
          density: "compact",
          class: "mx-2",
          "aria-label": `Remove ${category.label}`,
          onClick: $event => removeCodeSet(category)
        }, null, 8, ["aria-label", "onClick"])]);
      }), 128))]), _cache[17] || (_cache[17] = _createElementVNode("p", null, [_createElementVNode("i", null, "If you do not see the code set you need, let us know and we can add it.")], -1))], 512), [[_vShow, _unref(ledesState).form.ledes]]), _createVNode(SettingsSaveBar, {
        somethingChanged: somethingChanged.value,
        saving: _unref(ledesState).saving,
        unsaved: _unref(ledesState).unsaved,
        onUpdate: update,
        onCancel: cancel
      }, null, 8, ["somethingChanged", "saving", "unsaved"])])) : _createCommentVNode("", true)]))], 64);
    };
  }
};